<body></body>
<div class="page-container" style="min-height:200px">
    <!--Page content -->
    <div (resize)="onResize($event)" class="page-content text-center" *ngIf="pdfSrc.url">

            <pdf-viewer
                #pdfViewer
                [src]="pdfSrc.url"
                [(page)]="page"
                [rotation]="rotation"
                [show-all]="true"
                [zoom]="zoom"
                [render-text]="false"
                [external-link-target]="'blank'"
                (error)="onError($event)"
                (after-load-complete)="afterLoadComplete($event)"
                style="display: block; width: 100%; height: 100%; position: absolute;">
            </pdf-viewer>

    </div>
</div>


<!--Modal Info-->
<div *ngIf="modalInfoVisibility" id="jobDetailsInfoModal" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog modal-lg center-modal" role="document">
        <div class="modal-content">
            <div class="modal-header bg-primary clearfix">
                <div>
                    <button class="btn btn-link pull-right" type="button" data-dismiss="modal">x</button>
                </div>
                <div class="row col-md-11 col-sm-10 col-xs-10">
                    <div class="col-md-11 col-sm-11 col-xs-10">
                        <h3 class="modal-title">{{theJob?.name}}</h3>
                    </div>
                    <div class="col-md-1 col-sm-1 col-xs-2">
                        <!--<div *ngIf="theJob?.status == 'NONE'">-->
                          <!--<h1><span class="label label-default" translate>NONE</span></h1>-->
                        <!--</div>-->
                        <div *ngIf="theJob?.status == 'DRAFT'">
                          <h3><span class="label label-default" translate>DRAFT</span></h3>
                        </div>
                        <div *ngIf="theJob?.status == 'IN_PROGRESS'">
                          <h3><span class="label label-warning" translate>IN_PROGRESS</span></h3>
                        </div>
                        <div *ngIf="theJob?.status == 'REJECTED'">
                          <h3><span class="label label-danger" translate>REJECTED</span></h3>
                        </div>
                        <div *ngIf="theJob?.status == 'COMPLETED'">
                          <h3><span class="label label-success" translate>COMPLETED</span></h3>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-body">
                <div class="container-fluid">
                    <div class="row">
                      <ul class="list-inline">
                        <li *ngIf="jobOwner">
                          <h4>
                            <img src="https://cdn3.iconfinder.com/data/icons/real-estate-volume-3-1/48/135-32.png" alt="Job Owner" style="vertical-align:middle" >
                            <span>{{jobOwner}}</span>&nbsp;
                            <button *ngIf="isTeamMember == false && this.authorization.userAccount.subscription.plan.teammembers > 0" [disabled]="!changeDepartmentVisibility()" type="button" data-toggle="modal" class="btn btn-primary" data-target="#changeDepartmentModal" (click)="showChangeDepartment()">{{translate.instant("Change Organization Member")}}</button>
                          </h4>
                        </li>
                        <li *ngIf="theJob?.shared"><strong translate>Requested:</strong> {{theJob.shared | date: 'dd/MM/yyyy'}}</li>
                      </ul>
                    </div>
                    <div class="row" *ngIf="theJob?.sufficientDeadline != null && theJob?.status != 'COMPLETED'">
                      <div class="col-md-2"></div>
                      <div class="col-md-10">
                        <i class="icon-info3" style="padding:5px; margin-right: 5px; margin-left: 3%; background-color: e5e5e5; color: blue; border-radius: 1px; font-size: 18px;"></i><b>{{translate.instant("Sufficient signatures have been reached on the document, the document will be closed on: ")}}{{theJob.sufficientDeadline | date: 'dd/MM/yyyy'}}</b>
                      </div>
                    </div>
                  <br>

                  <h4 translate>Recipients</h4>
                  <div *ngFor="let container of containers; let i = index">
                      <div class="panel panel-flat border-grey-300 border-*-info inner-shadow">
                          <div class="panel-body">
                              <div class="row position">
                                <div class="col-md-1 col-sm-1 col-xs-1" style="text-align: center">
                                  <strong class="order-number" [ngClass]="assignGroupNumberStyle(i)">{{i+1}}</strong><br>
                                  <img *ngIf="checkSufficientShareValidity(container)" src="../../assets/images/pie-chart-2.jpg" style="width: 85%;margin-top: 5px; border-radius: 50%;">
                                  <span *ngIf="checkSufficientShareValidity(container)" class="sufficient-share-label">{{getGroupSufficientShare(i)}}</span>
                                </div>
                                <div class="col-md-11 col-sm-11 col-xs-11 border-left">
                                  <ul class="list-group no-border">
                                    <li *ngFor="let recipient of container.widgets; let x = index">
                                      <div class="row">
                                        <div [ngClass]="getNameClasses(recipient)">
                                          <h5 class="panel-title">{{recipient?.name}}
                                            <i *ngIf="signingLinkRetrievedRecipients.has(recipient.id)"
                                               class="icon-link" style="color: #f0ad4e; font-size: 12px; margin-left: 5px;"
                                               title="{{ 'Signing link was shared manually' | translate }}"></i>
                                            <span *ngIf="recipient?.sufficientshare != null" style="font-weight: bold;">
                                              ({{recipient?.share}} {{translate.instant("Shares")}})
                                            </span>
                                          </h5>
                                        </div>
                                        <div *ngIf="isRecipientUpdateAllowed && recipient.status == 'INLINE'" class="col-md-2 col-sm-2 col-xs-2 text-right">
                                          <button type="button" class="btn btn-xs btn-default" (click)="showRecipent(recipient)"
                                                  title="{{ 'Update' | translate }}">
                                            <i class="icon-pencil3"></i>
                                          </button>
                                        </div>
                                        <div *ngIf="isRecipientUpdateAllowed && recipient.status == 'WAITING'" class="col-md-4 col-sm-6 col-xs-6 text-center">
                                          <button type="button" class="btn btn-xs btn-default" (click)="resendRequest(recipient.id)" translate>Resend the request</button>
                                          <button type="button" class="btn btn-xs btn-default" style="margin-left: 3px;" (click)="getSigningLink(recipient)"
                                                  title="{{ 'Get Signing Link' | translate }}">
                                            <i class="icon-link"></i>
                                          </button>
                                          <button type="button" class="btn btn-xs btn-default" style="margin-left: 3px;" (click)="showRecipent(recipient)"
                                                  title="{{ 'Update' | translate }}">
                                            <i class="icon-pencil3"></i>
                                          </button>
                                        </div>
                                        <div class="col-md-2 col-sm-2 col-xs-3 text-center">
                                          <ng-container *ngIf="theJob.status != 'DRAFT'">
                                            <div *ngIf="recipient?.status == 'INLINE'">
                                              <h5> <span class="label label-default" translate>IN-LINE</span> </h5>
                                            </div>
                                            <div *ngIf="recipient?.status == 'WAITING'">
                                              <h5> <span class="label label-warning" translate>WAITING</span> </h5>
                                            </div>
                                            <div *ngIf="recipient?.status == 'SIGNED'">
                                              <h5> <span class="label label-success" translate>SIGNED</span> </h5>
                                            </div>
                                            <div *ngIf="recipient?.status == 'DECLINED'">
                                              <h5> <span class="label label-danger" translate>DECLINED</span> </h5>
                                            </div>
                                            <div *ngIf="recipient?.status == 'REVOKED'">
                                              <h5> <span class="label label-warning" translate>REVOKED</span> </h5>
                                            </div>
                                          </ng-container>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-md-10 col-sm-10 col-xs-9">
                                          <ul class="list-inline">
                                            <li *ngIf="recipient?.email" class="no-border"><i class="icon-mail5"></i>{{recipient?.email}}</li>
                                            <li *ngIf="recipient?.citizenId" class="no-border"><i class="icon-vcard"></i>{{recipient?.citizenId}}</li>
                                            <li *ngIf="recipient?.smsRequired" class="no-border"><i class="icon-mobile"></i>{{recipient?.smsRequired == "" ? "-" : "(+" + recipient.smsCountryCode + ") " + recipient.smsRequired }}</li>
                                          </ul>
                                        </div>
                                        <div class="col-md-2 col-sm-2 col-xs-3 text-center">
                                          <p>{{recipient?.updated | date: 'dd/MM/yyyy'}}</p>
                                        </div>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                          </div>
                      </div>
                  </div>

                  <h4 translate>Details</h4>

                  <div class="panel panel-flat border-grey-300 border-*-info inner-shadow">
                    <div class="panel-body">
                      <table class="table table-md table-sm table-xs table-borderless">
                        <tbody>
                            <tr>
                                <th class="col-md-2 col-sm-2 col-xs-3"><strong translate>Name</strong></th>
                                <td class="col-md-10 col-sm-10 col-xs-9">{{theJob?.documents[0].name}}</td>
                            </tr>
                            <tr>
                              <th class="col-md-2 col-sm-2 col-xs-3"><strong translate>Process No</strong></th>
                              <td class="col-md-10 col-sm-10 col-xs-9">#{{theJob?.id}}</td>
                            </tr>
                            <tr>
                                <th class="col-md-2 col-sm-2"><strong translate>Page</strong></th>
                                <td class="col-md-10 col-sm-10">{{theJob?.documents[0]?.page}}</td>
                            </tr>
                            <tr>
                                <th class="col-md-2 col-sm-2 col-xs-3"><strong translate>Size</strong></th>
                                <td class="col-md-10 col-sm-10 col-xs-9">{{theJob?.documents[0]?.size}} KB</td>
                            </tr>
                            <tr>
                                <th class="col-md-2 col-sm-2 col-xs-3"><strong translate>Uploaded</strong></th>
                                <td class="col-md-10 col-sm-10 col-xs-9">{{theJob?.documents[0]?.created | date: 'dd/MM/yyyy'}}</td>
                            </tr>
                            <tr>
                                <th class="col-md-2 col-sm-2 col-xs-3"><strong translate>Last Update</strong></th>
                                <td class="col-md-10 col-sm-10 col-xs-9">{{theJob?.updated | date: 'dd/MM/yyyy'}} </td>
                            </tr>
                            <tr>
                              <th class="col-md-2 col-sm-2 col-xs-3"><strong translate>Location</strong></th>
                              <td class="col-md-10 col-sm-10 col-xs-9">{{translate.instant(jobLocation)}} </td>
                            </tr>
                            <tr>
                              <th class="col-md-2 col-sm-2 col-xs-3"><strong translate>Labels</strong></th>
                              <td class="col-md-10 col-sm-10 col-xs-9">
                                <div class="form-group">
                                  <div class="tags" *ngFor="let tag of theJob?.tags;">
                                    <span class="tag label label-primary">{{tag}}</span>
                                  </div>
                                </div>
                              </td>
                            </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-link" type="button" data-dismiss="modal" translate>Close</button>
            </div>
        </div>
    </div>
</div>
<!--Modal Info-->

<!--Modal Validation-->
<div *ngIf="validationModalVisible" id="validationModal" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog center-modal" role="document" style="width: 90%; max-width: 1200px;">
    <div class="modal-content">
      <div class="modal-header clearfix" [ngClass]="getValidationHeaderClass()">
        <button class="btn btn-link pull-right" type="button" data-dismiss="modal" style="color: white;">×</button>
        <button class="btn btn-default pull-right" type="button" (click)="validateDocument()" [disabled]="validationLoading" style="margin-right: 10px;">
          <i class="icon-checkmark3"></i> {{ 'VALIDATE' | translate }}
        </button>
        <h5 class="modal-title">
          <i [ngClass]="getValidationIcon()"></i>
          {{ 'Document Validation' | translate }}
          <span *ngIf="validationResult" class="label" [ngClass]="getResultLabelClass(validationResult.resultType)">
            {{ getResultTypeText(validationResult.resultType) }}
          </span>
        </h5>
      </div>
      <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">
        <!-- Loading -->
        <div *ngIf="validationLoading" class="text-center" style="padding: 40px;">
          <i class="icon-spinner2 spinner" style="font-size: 32px;"></i>
          <p style="margin-top: 15px;">{{ 'VALIDATING' | translate }}...</p>
        </div>

        <!-- Error -->
        <div *ngIf="validationError" class="alert alert-danger">
          <i class="icon-warning"></i> {{ validationError }}
        </div>

        <!-- Results -->
        <div *ngIf="validationResult && !validationLoading">
          <!-- Overall Result Banner -->
          <div class="alert" [ngClass]="getResultAlertClass(validationResult.resultType)" style="margin-bottom: 20px;">
            <h4 style="margin: 0;">
              <i [ngClass]="getResultIcon(validationResult.resultType)"></i>
              {{ getResultText(validationResult.resultType) }}
            </h4>
            <small>{{ validationResult.signatures?.length || 0 }} {{ 'signature(s) found' | translate }}</small>
          </div>

          <!-- Signatures Accordion -->
          <div class="panel-group" id="validationAccordion">
            <div class="panel" [ngClass]="getSignaturePanelClass(sig.resultType)" *ngFor="let sig of validationResult.signatures; let i = index">
              <!-- Signature Header -->
              <div class="panel-heading" style="cursor: pointer;" (click)="toggleValidationPanel('sig-' + i)">
                <h4 class="panel-title" style="display: flex; align-items: center; justify-content: space-between;">
                  <span>
                    <i [ngClass]="getResultIcon(sig.resultType)" style="margin-right: 8px;"></i>
                    <strong>{{ extractCN(sig.certificate?.subjectDN) || sig.signature?.pdfFieldName || ('Signature' | translate) + ' ' + (i + 1) }}</strong>
                    <span class="label" [ngClass]="getResultLabelClass(sig.resultType)" style="margin-left: 10px;">
                      {{ getResultTypeText(sig.resultType) }}
                    </span>
                    <span *ngIf="sig.signature?.isTimestamp" class="label label-info" style="margin-left: 5px;">
                      {{ 'Timestamp' | translate }}
                    </span>
                  </span>
                  <i [ngClass]="expandedPanels['sig-' + i] ? 'icon-arrow-up5' : 'icon-arrow-down5'"></i>
                </h4>
              </div>

              <!-- Signature Body -->
              <div class="panel-collapse" [ngClass]="{'in': expandedPanels['sig-' + i]}" *ngIf="expandedPanels['sig-' + i]">
                <div class="panel-body">
                  <!-- Detailed Message -->
                  <div *ngIf="sig.detailedMessage" class="alert" [ngClass]="getResultAlertClass(sig.resultType)" style="margin-bottom: 15px;">
                    <i [ngClass]="getResultIcon(sig.resultType)"></i>
                    {{ sig.detailedMessage }}
                  </div>

                  <!-- Signature Info -->
                  <div class="row">
                    <div class="col-md-6">
                      <h5 style="border-bottom: 1px solid #ddd; padding-bottom: 5px;">
                        <i class="icon-pencil3"></i> {{ 'Signature Info' | translate }}
                      </h5>
                      <table class="table table-condensed table-bordered" style="font-size: 12px; table-layout: fixed;">
                        <tr><td style="width: 120px; white-space: normal; word-wrap: break-word;"><strong>{{ 'Format' | translate }}</strong></td><td>{{ sig.signature?.signatureFormat }}</td></tr>
                        <tr><td style="white-space: normal; word-wrap: break-word;"><strong>{{ 'Type' | translate }}</strong></td><td>{{ sig.signature?.signatureType }}</td></tr>
                        <tr><td style="white-space: normal; word-wrap: break-word;"><strong>{{ 'Algorithm' | translate }}</strong></td><td>{{ sig.signature?.signatureAlg?.name }}</td></tr>
                        <tr *ngIf="sig.signature?.signingTime"><td style="white-space: normal; word-wrap: break-word;"><strong>{{ 'Signing Time' | translate }}</strong></td><td>{{ sig.signature?.signingTime | date:'medium' }}</td></tr>
                        <tr *ngIf="sig.signature?.timeStampTime"><td style="white-space: normal; word-wrap: break-word;"><strong>{{ 'Timestamp' | translate }}</strong></td><td>{{ sig.signature?.timeStampTime | date:'medium' }}</td></tr>
                      </table>
                    </div>

                    <!-- Certificate Info -->
                    <div class="col-md-6">
                      <h5 style="border-bottom: 1px solid #ddd; padding-bottom: 5px; cursor: pointer;" (click)="toggleValidationPanel('cert-' + i)">
                        <i class="icon-certificate"></i> {{ 'Certificate' | translate }}
                        <i [ngClass]="expandedPanels['cert-' + i] ? 'icon-arrow-up5' : 'icon-arrow-down5'" style="float: right;"></i>
                      </h5>
                      <div *ngIf="expandedPanels['cert-' + i]">
                        <table class="table table-condensed table-bordered" style="font-size: 11px; table-layout: fixed;">
                          <tr><td style="width: 100px; white-space: normal; word-wrap: break-word;"><strong>{{ 'Subject' | translate }}</strong></td><td style="word-break: break-all;">{{ sig.certificate?.subjectDN }}</td></tr>
                          <tr><td style="white-space: normal; word-wrap: break-word;"><strong>{{ 'Issuer' | translate }}</strong></td><td style="word-break: break-all;">{{ sig.certificate?.issuerDN }}</td></tr>
                          <tr><td style="white-space: normal; word-wrap: break-word;"><strong>{{ 'Serial' | translate }}</strong></td><td>{{ sig.certificate?.serialNumber }}</td></tr>
                          <tr><td style="white-space: normal; word-wrap: break-word;"><strong>{{ 'Valid From' | translate }}</strong></td><td>{{ sig.certificate?.notBefore | date:'medium' }}</td></tr>
                          <tr><td style="white-space: normal; word-wrap: break-word;"><strong>{{ 'Valid Until' | translate }}</strong></td><td>{{ sig.certificate?.notAfter | date:'medium' }}</td></tr>
                        </table>
                      </div>
                      <div *ngIf="!expandedPanels['cert-' + i]" style="font-size: 12px; color: #666;">
                        {{ extractCN(sig.certificate?.subjectDN) }}
                      </div>
                    </div>
                  </div>

                  <!-- Certificate Chain -->
                  <div *ngIf="sig.certificateChain?.length > 0" style="margin-top: 15px;">
                    <h5 style="border-bottom: 1px solid #ddd; padding-bottom: 5px; cursor: pointer;" (click)="toggleValidationPanel('chain-' + i)">
                      <i class="icon-link"></i> {{ 'Certificate Chain' | translate }} ({{ sig.certificateChain.length }})
                      <i [ngClass]="expandedPanels['chain-' + i] ? 'icon-arrow-up5' : 'icon-arrow-down5'" style="float: right;"></i>
                    </h5>
                    <div *ngIf="expandedPanels['chain-' + i]">
                      <div *ngFor="let cert of sig.certificateChain" class="well well-sm" style="margin-bottom: 5px; font-size: 11px;">
                        <span class="label" [ngClass]="cert.type === 'ROOT_CA' ? 'label-primary' : 'label-default'">{{ cert.type }}</span>
                        <strong>{{ extractCN(cert.subject) }}</strong>
                        <br><small class="text-muted">{{ 'Issuer' | translate }}: {{ extractCN(cert.issuer) }}</small>
                      </div>
                    </div>
                  </div>

                  <!-- Validation Details -->
                  <div style="margin-top: 15px;">
                    <h5 style="border-bottom: 1px solid #ddd; padding-bottom: 5px; cursor: pointer;" (click)="toggleValidationPanel('details-' + i)">
                      <i class="icon-list-unordered"></i> {{ 'Validation Details' | translate }}
                      <i [ngClass]="expandedPanels['details-' + i] ? 'icon-arrow-up5' : 'icon-arrow-down5'" style="float: right;"></i>
                    </h5>
                    <div *ngIf="expandedPanels['details-' + i]">
                      <ul class="list-unstyled" style="margin: 0;">
                        <li *ngFor="let detail of sig.validationDetails" style="padding: 8px 0; border-bottom: 1px solid #eee;">
                          <i [ngClass]="getResultIcon(detail.resultType)" style="margin-right: 8px;"></i>
                          <span [ngClass]="getResultTextClass(detail.resultType)">{{ detail.checkResult }}</span>
                          <!-- Nested details (for timestamp) -->
                          <ul *ngIf="detail.details?.length > 0" style="margin-top: 5px; margin-left: 20px;">
                            <li *ngFor="let subDetail of detail.details" style="padding: 3px 0; font-size: 12px;">
                              <i [ngClass]="getResultIcon(subDetail.resultType)" style="margin-right: 5px;"></i>
                              <span [ngClass]="getResultTextClass(subDetail.resultType)">{{ subDetail.checkResult }}</span>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <!-- Revocation Check -->
                  <div *ngIf="sig.revocationCheck?.length > 0" style="margin-top: 15px;">
                    <h5 style="border-bottom: 1px solid #ddd; padding-bottom: 5px; cursor: pointer;" (click)="toggleValidationPanel('revoke-' + i)">
                      <i class="icon-shield-check"></i> {{ 'Revocation Check' | translate }}
                      <i [ngClass]="expandedPanels['revoke-' + i] ? 'icon-arrow-up5' : 'icon-arrow-down5'" style="float: right;"></i>
                    </h5>
                    <div *ngIf="expandedPanels['revoke-' + i]">
                      <table class="table table-condensed table-bordered" style="font-size: 12px;">
                        <tr *ngFor="let rev of sig.revocationCheck">
                          <td>{{ rev.checkText }}</td>
                          <td>
                            <span class="label" [ngClass]="getRevocationLabelClass(rev.revocationCheckResult)">
                              {{ rev.resultText }}
                            </span>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Initial State -->
        <div *ngIf="!validationResult && !validationLoading && !validationError" class="text-center text-muted" style="padding: 40px;">
          <i class="icon-file-check" style="font-size: 48px; color: #ccc;"></i>
          <p style="margin-top: 15px;">{{ 'CLICK_VALIDATE_TO_CHECK' | translate }}</p>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-link" type="button" data-dismiss="modal" translate>Close</button>
      </div>
    </div>
  </div>
</div>
<!--Modal Validation-->

<!--Modal Activity History-->
<div id="jobDetailsActivityHistoryModal" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-lg modal-md center-modal" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary-300">
        <button class="close" type="button" data-dismiss="modal">×</button>
        <h5 class="text-semibold modal-title" translate>Event History (Audit Trail)</h5>
      </div>

      <div class="modal-body">
        <div class="table-responsive">
          <table class="table table-md table-sm table-bordered table-striped table-condensed">
            <thead>
              <tr class="active">
                <th translate>DATE (GMT)</th>
                <th translate>USER</th>
                <th translate>ACTIVITY</th>
                <th translate>Information</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
             <tr *ngFor="let auditLog of theJobHistory;" role="row" class="odd">
               <td>{{auditLog?.time | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
               <td>{{auditLog?.name}} / {{auditLog?.email}}</td>
               <td>{{auditLog?.activity}}</td>
               <td>{{getAuditLogInfo(auditLog?.info)}}</td>
               <td><a [attr.href]="null" (click)="showHistoryDetails(auditLog)" data-toggle="modal" data-target="#activityHistoryDetailsModal" translate>Details</a></td>
             </tr>
            </tbody>
          </table>
        </div>
      </div>
      <hr>
      <div class="modal-footer">
        <button class="btn btn-link" type="button" data-dismiss="modal" translate>Close</button>
      </div>
    </div>
  </div>
</div>


<div id="activityHistoryDetailsModal" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-md model-sm center-modal modal-vertical-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary-600">
        <button class="close" type="button" data-dismiss="modal">×</button>
        <h5 class="text-semibold modal-title" translate>Details</h5>
      </div>
      <div class="modal-body">
        <div class="table-responsive">
          <table class="table table-sm table-xs table-borderless">
            <tbody>
            <tr>
              <th class="col-sm-2 col-xs-2"><strong translate>IP</strong></th>
              <td class="col-sm-10 col-xs-10">{{selectedAuditLog?.ipAddress}}</td>
            </tr>
            <tr>
              <th class="col-sm-2 col-xs-2"><strong translate>Agent</strong></th>
              <td class="col-sm-10 col-xs-10">{{selectedAuditLog?.agent}}</td>
            </tr>
            <tr *ngIf="selectedAuditLogDetail">
              <th class="col-sm-2 col-xs-2"><strong>{{selectedAuditLogDetail[0]}}</strong></th>
              <td class="col-sm-10 col-xs-10" style="word-break: break-all">{{selectedAuditLogDetail[1]}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <hr>
      <div class="modal-footer">
        <button class="btn btn-link" type="button" data-dismiss="modal" translate>Close</button>
      </div>
    </div>
  </div>
</div>
<!--Modal Activity History-->


<!--Modal Tag-->
<div id="jobDetailsTagModal" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-md center-modal" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <button class="close" type="button" data-dismiss="modal">×</button>
        <h5 class="text-semibold modal-title">{{translate.instant('Tags')}}</h5>
      </div>
       <div class="modal-body">
         <p translate>If this document relates to which subject or categories, add it here as a label.</p>
          <div class="panel panel-flat border-grey-300 border-*-info inner-shadow">
            <div class="panel-body">
              <div class="wrapper">
                <div class="content-group">
                  <input type="text" class="tags-input" [placeholder]="translate.instant('+ Tag')"/>
                </div>
              </div>
            </div>
          </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-link" type="button" data-dismiss="modal" translate>Close</button>
        <button class="btn btn-primary" type="button" (click)="updateLabels('tags')" data-dismiss="modal" translate>Update</button>
      </div>
  </div>
</div>
</div>
<!--Modal Tag-->

<!--Modal Name-->
<div id="jobDetailsChangeNameModal" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-md center-modal" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <button class="close" type="button" data-dismiss="modal">×</button>
        <h5 class="text-semibold modal-title" translate>Change Name</h5>
      </div>
      <div class="modal-body">
        <div class="row col-sm-10 col-sm-offset-1">
          <div class="form-group">
            <label>Name:</label>
            <input class="form-control" type="text" [(ngModel)]="jobNewName">
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-link" type="button" data-dismiss="modal" translate>Close</button>
        <button class="btn btn-primary" type="button" (click)="updateLabels('name')" data-dismiss="modal" translate>Change</button>
      </div>
    </div>
  </div>
</div>
<!--Modal Name-->

<!--Public Link-->
<div *ngIf="currentToolbar" id="publicLink" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-md center-modal" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <button class="close" type="button" data-dismiss="modal">×</button>
        <h5 class="text-semibold modal-title" translate>Public Link</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-12">
            <div class="input-group">
              <input type="text" class="form-control" readonly [(ngModel)]="currentToolbar.sharePublicLink" #publicLink>
              <span class="input-group-btn">
                <button class="btn btn-default" type="button" [ngxClipboard]="publicLink" (cbOnSuccess)="notificationService?.publicLinkCopied()"><span class="icon-copy3"></span> {{ 'COPY' | translate}}</button>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <!--<button class="btn btn-link" type="button" data-dismiss="modal" translate>Close</button>-->
        <button class="btn btn-primary" type="button" data-dismiss="modal" translate>Done</button>
      </div>
    </div>
  </div>
</div>
<!--Public Link-->

<!--Signing Link Modal-->
<div id="signingLinkModal" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-md center-modal" role="document">
    <div class="modal-content">
      <div class="modal-header bg-warning">
        <button class="close" type="button" data-dismiss="modal">&times;</button>
        <h5 class="text-semibold modal-title">
          <i class="icon-link"></i> {{ 'Signing Link' | translate }}
        </h5>
      </div>
      <div class="modal-body">
        <div class="row" style="margin-bottom: 15px;">
          <div class="col-sm-12">
            <p>
              <strong>{{ 'Recipient' | translate }}:</strong> {{ signingLinkRecipient?.name }}
            </p>
            <p>
              <i class="icon-mail5"></i> {{ signingLinkRecipient?.email }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <label translate>Signing Link</label>
            <div class="input-group">
              <input type="text" class="form-control" readonly [value]="signingLinkUrl" #signingLink>
              <span class="input-group-btn">
                <button class="btn btn-default" type="button"
                        [ngxClipboard]="signingLink"
                        (cbOnSuccess)="notificationService?.signingLinkCopied()">
                  <span class="icon-copy3"></span> {{ 'COPY' | translate }}
                </button>
              </span>
            </div>
          </div>
        </div>
        <div class="row" style="margin-top: 10px;">
          <div class="col-sm-12">
            <p class="text-warning" style="font-size: 12px;">
              <i class="icon-warning"></i>
              {{ 'Anyone with this link can see the document as this recipient. Share it securely.' | translate }}
            </p>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" type="button" data-dismiss="modal" translate>Done</button>
      </div>
    </div>
  </div>
</div>
<!--Signing Link Modal-->

<!-- modal-edit-recipient -->
<!--Eger birisinin arayuzu degisirse, bir fix yaparsak digerinde de degisiklik yapmamiz gerekiyor-->
<div *ngIf="theRecipient" id="updateDetailRecipient" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h6 class="modal-title" translate>Update Recipient</h6>
      </div>
      <!--<form>-->
      <form #f="ngForm" novalidate>
        <!--(ngSubmit)="save(f.value, f.valid)"-->
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
              <div class="form-group form-group-material">
                <label for="name" class="control-label is-visible"><strong translate>Name</strong></label>
                <input type="text" id="name" name="name" class="form-control" [placeholder]="translate.instant('Name')" [(ngModel)]="theRecipient.name" #name="ngModel" required minlength="2" pattern="^[a-zA-ZçÇöÖşŞıİğĞüÜ]+([',.\s-][a-zA-ZçÇöÖşŞıİğĞüÜ]+)*$">
                <!--show error only when field is not valid & it's dirty or form submited-->
                <small [hidden]="name.valid || (name.pristine && !f.submitted)" class="text-danger" translate>Name is required.</small>
              </div>
              <div class="form-group form-group-material">
                <label for="email" class="control-label is-visible"><strong translate>Email</strong></label>
                <input type="email" id="email" name="email" class="form-control" [disabled]="isDisabled" placeholder="john@doe.com" [(ngModel)]="theRecipient.email" #email="ngModel" required minlength="5" (input)="theRecipient.email = theRecipient.email?.toLowerCase()">
                <!--show error only when field is not valid & it's dirty or form submited-->
                <small [hidden]="email.valid || (email.pristine && !f.submitted)" class="text-danger" [innerHTML]="'EMAIL_REQUIRED_JOBDETAILS' | translate"></small>
              </div>
              <div class="form-group form-group-material">
                <label for="email" class="control-label is-visible"><strong>{{translate.instant('Verification Methods')}}</strong></label>
                <div class="form-check">
                  <div class="row">
                    <div class="col-md-4" id="noneVerifyContainer" (click)="checkVerificationRadioButton('none')">
                      <input class="form-check-input clickable" type="radio" name="verificationRadioButton" id="noneRadioButton" value="none" [(ngModel)]="recipientVerificationStatus" checked/>
                      <label class="form-check-label clickable" for="verificationRadioButton" style="font-size: 15px;"> <i class="icon-cross" style="font-size: 25px; margin-left: 10px;" ></i> {{translate.instant('None')}}</label>
                    </div>
                    <div class="col-md-4" id="mobileVerifyContainer" (click)="checkVerificationRadioButton('mobile')">
                      <input class="form-check-input clickable" type="radio" name="verificationRadioButton" id="mobileRadioButton" value="mobile" [(ngModel)]="recipientVerificationStatus"/>
                      <label class="form-check-label clickable" for="verificationRadioButton" style="font-size: 15px;"> <i class="icon-mobile" style="font-size: 25px; margin-left: 10px;" ></i> SMS</label>
                    </div>
                    <div class="col-md-4" id="identityVerifyContainer" (click)="checkVerificationRadioButton('identity')">
                      <input class="form-check-input clickable" type="radio" name="verificationRadioButton" id="identityRadioButton" value="identity" [(ngModel)]="recipientVerificationStatus"/>
                      <label class="form-check-label clickable" for="verificationRadioButton" style="font-size: 15px;"> <i class="icon-vcard" style="font-size: 23px; margin-left: 10px;" ></i> {{translate.instant('Citizen ID')}}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div [hidden]="recipientVerificationStatus != 'identity'" class="form-group form-group-material">
                <label for="citizenId" class="control-label is-visible"><strong translate>Citizen ID</strong></label>
                <input [disabled]="recipientVerificationStatus == 'mobile' || recipientVerificationStatus == 'none'" type="text" id="citizenId" name="citizenId" class="form-control" [placeholder]="translate.instant('Citizen ID')" [(ngModel)]="theRecipient.citizenId" #citizenId="ngModel" minlength="11" maxlength="11" pattern="[0-9]+" [required]="recipientVerificationStatus == 'identity'">
                <!--show error only when field is not valid & it's dirty or form submited-->
                <small [hidden]="citizenId.valid || (citizenId.pristine && !f.submitted)" class="text-danger">{{translate.instant("Citizen ID (11 numeric characters).")}}</small>
              </div>
              <div [hidden]="recipientVerificationStatus != 'mobile'" class="form-group form-group-material">
                <label for="smsRequired" class="control-label is-visible"><strong>{{translate.instant('Phone Number')}}</strong></label>
                <div class="row">
                  <div class="col-md-4" style="padding-right: 0px;">
                    <div class="dropdown">
                      <button class="btn btn-secondary dropdown-toggle" style="width: 100%;" type="button" data-toggle="dropdown"><img src="../../assets/images/country_flags/{{currentCountryFlag.fileName}}" class="country-flag"> {{currentCountryFlag.isoCode}} +{{currentCountryFlag.countryCode}}<span class="caret"></span></button>
                      <ul class="dropdown-menu scrollable-menu" style="min-width: 100%;">
                        <ng-container *ngFor="let listItem of countryFlags">
                          <li class="clickable country-code-list-item" (click)="pickCountry(listItem)" [title]="translate.instant(listItem.countryName)">
                            <img src="../../assets/images/country_flags/{{listItem.fileName}}" class="country-flag">{{translate.instant(listItem.countryName)}} - <b>(+{{listItem.countryCode}})</b>
                          </li>
                        </ng-container>
                      </ul>
                    </div>
                  </div>
                  <div class="col-md-8" style="padding-left: 0px;">
                    <input [disabled]="recipientVerificationStatus == 'identity' || recipientVerificationStatus == 'none'" type="text" id="smsRequired" name="smsRequired" class="form-control" placeholder="{{translate.instant('Phone Number')}}" [(ngModel)]="theRecipient.smsRequired" #smsRequired="ngModel" maxlength="{{calculatePhoneNumberLength(currentCountryFlag)}}" pattern="[0-9]+" [required]="recipientVerificationStatus == 'mobile'">
                  </div>
                </div>
                <!--show error only when field is not valid & it's dirty or form submited-->
                <small [hidden]="smsRequired.valid || (smsRequired.pristine && !f.submitted)" class="text-danger" translate [translateParams]="{phoneLength:currentCountryFlag.phoneLength}">PHONE_NUMBER_ERROR_JOBDETAILS</small>
              </div>
            </div>
          </div>
          <br><br>
          <hr>
          <div class="row">
            <div class="col-md-11 col-sm-11 col-xs-11 text-right">
              <button type="button" class="btn btn-default btn-size" (click)="updateRecipient(theRecipient)" [disabled]="!f.valid" translate>Update</button>
              <button type="button" class="btn btn-link pull-right" data-dismiss="modal" translate>Cancel</button>
            </div>
          </div>
        </div>
      </form>
      <!--</form>-->
    </div>
  </div>
</div>
<!-- /modal -->

<div *ngIf="templateVisibility" id="jobTemplate" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-lg center-modal" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <button class="close" type="button" data-dismiss="modal">×</button>
        <h5 class="text-semibold modal-title" translate>Templates</h5>
      </div>
      <div class="modal-body">
        <br>
        <ul class="list-group" *ngFor="let job of templateJobs;">
          <li class="list-group-item">
            <div class="row position">
              <div class="col-xs-10">
                <div style="font-weight: bold; font-size: 16px; display: flex; align-items: center;">
                  {{job.name}}
                  <span *ngIf="isApiVersionMismatch(job)" style="color: #ff8c00; font-size: 20px; margin-left: 10px; cursor: help;" [title]="'TEMPLATE_OLD_COORDINATE_SYSTEM' | translate">⚠</span>
                </div>
                <span *ngFor="let recipient of job.recipients; let isLast=last" class="text-muted">
                  {{recipient.name}}{{isLast ? '' : ', '}}
                </span>
              </div>
              <div class="col-xs-2 text-right">
                <button class="btn btn-primary" type="button" (click)="chooseTemplate(job.id)" translate>Choose</button>
              </div>
            </div>
          </li>
        </ul>

      </div>
      <div class="modal-footer">
        <button class="btn btn-link" type="button" data-dismiss="modal" translate>Cancel</button>
      </div>
    </div>
  </div>
</div>

<div id="sftpList" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-md center-modal" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <button class="close" type="button" data-dismiss="modal">×</button>
        <h5 class="text-semibold modal-title">{{translate.instant("Please select a target")}}</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-1"></div>
          <div class="col-md-9">
            <div *ngFor="let server of sftpDetails">
              <div class="form-check" style="border: 1px black solid; margin: 7px; border-radius: 5px;" id="sftpListDiv_{{server.id}}" (click)="checkRadioButton(server.id)">
                <div class="row">
                  <div class="col-md-1">
                    <input class="form-check-input" type="radio" name="sftpRadioButton" id="sftpRadioButton_{{server.id}}" [value]="server.id" style="margin-left: 7px; margin-top: 10px;"/>
                  </div>
                  <div class="col-md-11">
                    <label class="form-check-label" for="sftpRadioButton" #sftpButton style="font-size: 15px;" style="margin-left: -8px; margin-top: 7px;">{{server.serverName}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-2"></div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-link" type="button" data-dismiss="modal" translate>Cancel</button>
        <button type="button" class="btn btn-primary" (click)="send2Sftp()" [disabled]="checkedSftpServer == null">{{translate.instant("Send")}}</button>
      </div>
    </div>
  </div>
</div>

<div id="createTemplate" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-sm center-modal" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <button class="close" type="button" data-dismiss="modal">×</button>
        <h5 class="text-semibold modal-title" translate>Create Template</h5>
      </div>
      <div class="modal-body">

        <form #f="ngForm" novalidate>
          <div class="form-group">
            <label for="category" class="control-label"><strong translate>Category</strong></label>
            <input type="text" id="category" name="category" class="form-control" [(ngModel)]="template.category" #category="ngModel">
          </div>
          <div class="form-group">
            <label for="definition" class="control-label"><strong translate>Definition</strong></label>
            <textarea class="form-control" id="definition" [(ngModel)]="template.definition" name="definition" #definition="ngModel" rows="6" cols="50"> </textarea>
          </div>
        </form>

      </div>
      <div class="modal-footer">
        <button class="btn btn-link" type="button" data-dismiss="modal" translate>Cancel</button>
        <button type="button" class="btn btn-primary" (click)="createTemplate()" [disabled]="false" translate>Create</button>
      </div>
    </div>
  </div>
</div>

<!-- Change Department -->
<div id="changeDepartmentModal" class="modal fade" style="top: 80px !important;" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-md center-modal" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <button class="close" type="button" data-dismiss="modal">×</button>
        <h5 class="text-semibold modal-title" translate>Change Organization Member</h5>
      </div>
      <form>
        <div class="modal-body">
          <ng-container *ngIf="currentDepartmentId == null">
            <strong style="margin-left:10px;color:red">{{translate.instant("No organization member has been assigned to this document.")}}</strong><br><br>
          </ng-container>
          <div class="form-group position position">
            <strong  class="col-sm-3 col-xs-3 text-left" style="font-size:18px">{{translate.instant("Member")}}</strong>
            <div class="col-sm-9 col-xs-9 text-left">
              <select style="font-size:16px" id="departmentDropdown">
                <option value="0" *ngIf="ownerTeamMembers.length > 0">{{authorization?.userProfile?.email == null ? "" : authorization?.userProfile?.email}} - {{translate.instant("Organization Owner")}}</option>
                <ng-container *ngFor="let member of ownerTeamMembers">
                  <option [selected]="member.id == currentDepartmentId" value="{{member.id}}"> {{member.memberEmail}} - {{member.branch}}</option>
                </ng-container>
              </select>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-link" type="button" data-dismiss="modal" translate>Cancel</button>
          <button class="btn btn-primary" type="submit" (click)="changeDepartment()">{{translate.instant("Güncelle")}}</button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- Change Department -->

<div *ngIf="sharingModalVisibility">
  <sd-sharing [document]="sharingDocument"></sd-sharing>
</div>

<!-- Attachments Modal (read-only for job details) -->
<div *ngIf="attachmentsModalVisibility">
  <app-attachments-modal
    [documentId]="theJob?.documents[0]?.id"
    [editable]="false"
    [jobName]="theJob?.name"
    (modalClosed)="onAttachmentsClosed()">
  </app-attachments-modal>
</div>
